// extracted by mini-css-extract-plugin
export default {"stepContainer":"stepContainer-Vgf3U","stepContentContainer":"stepContentContainer-gtyyK","container":"container-vv8NR","instruction":"instruction-zdqec"};